import React from "react";
import { formatTalkTime } from "../../Utils/role"; 

function SharedPlanBalance({ plan }) {
  const data = plan || {  callSeconds: 0 };

  return (
    <div className="">
      <div className="usage-header-row" />

      <div className="usage-numbers d-flex align-items-end gap-2">
        <div className="usage-big mb-0" style={{ fontSize: "1.5rem", fontWeight: "600" }}>
          {formatTalkTime(data.used)}
        </div>
        {/* <div className="text-muted mb-1" style={{ fontSize: "0.9rem" }}>
          of {formatTalkTime(data.limit)}
        </div> */}
      </div>

      {/* <div className="usage-bar my-2">
        <div
          className="usage-fill"
          style={{
            width: `${data.limit ? Math.min(100, (data.used / data.limit) * 100) : 0}%`,
          }}
        />
      </div> */}

      {/* <div className="d-flex justify-content-between align-items-center mt-2">
        <div className="usage-remaining mb-0" style={{ fontSize: "0.85rem" }}>
          <span className="dot-green-sm" />
          {formatTalkTime(data.left)} left
        </div>
        <div className="usage-remaining " style={{ fontSize: "0.85rem" }}>
          <span className="dot-orange-sm me-1" style={{ display: "inline-block", width: "6px", height: "6px", borderRadius: "50%", backgroundColor: "#ff9800" }} />
          {formatTalkTime(data.callSeconds)} used in this page
        </div>
      </div> */}
    </div>
  );
}

export default SharedPlanBalance;